export const Paths = {
  home: "/",
  login: "/login",
};
